const faqs = [
  {
    q: '片多多影视真的完全免费吗？',
    a: '是的，片多多影视坚持完全免费运营。所有电影、电视剧、综艺、动漫等内容均免费观看，无需注册、无需付费、无需会员。我们通过广告合作维持平台运营，为用户提供片多多高清免费、片多多免费观看的优质体验。',
  },
  {
    q: '片多多高清不卡是真的吗？怎么看高清？',
    a: '片多多影视采用先进的视频加速和CDN分发技术，确保片多多高清不卡的流畅观影体验。大部分内容支持1080P甚至4K超清画质，您只需在网络良好的环境下打开影片，系统会自动匹配最佳画质。如遇卡顿，可尝试切换清晰度。',
  },
  {
    q: '片多多影视的片库更新频率如何？',
    a: '片多多影视保持每日更新，热门电影、电视剧上线后会在第一时间同步到平台。综艺节目通常在播出后几小时内更新，动漫番剧也会及时跟进最新一集。我们的内容团队7x24小时持续扩充片库，确保您不错过任何精彩内容。',
  },
  {
    q: '片多多影视可以在手机上观看吗？',
    a: '当然可以！片多多影视全面支持手机端访问，您可以通过手机浏览器直接打开片多多影视网站观看，无需下载任何APP。页面已针对移动端进行适配优化，在小屏幕上也能享受片多多高清免费和片多多高清不卡的观影体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问题</h2>
            <p className="mt-3 text-sm text-foreground-500">关于片多多影视的常见疑问</p>
          </div>

          <div className="max-w-3xl mx-auto space-y-4">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-background-50 rounded-2xl p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-primary-600 text-sm font-bold">Q</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900">{faq.q}</h3>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}